module.exports = __webpack_public_path__ + "img/about-right-shape.d88b3ac7.svg";